import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const resEnvChecklistHallwaySchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  hallwayWall: environmentalChecklistItemWithTicket,
  hallwayLight: environmentalChecklistItemWithTicket,
  hallwayFloor: environmentalChecklistItemWithTicket,
  hallwayWindows: environmentalChecklistItemWithTicket,
  hallwayCurtains: environmentalChecklistItemWithTicket,
  hallwayComment: z.string().optional(),
});
